import type { ButtonPropSize, ButtonPropView } from '@consta/uikit/Button'
import { selectPreferredName, useAppSelector } from '@core/core/store'
import { getProjectDataAnalyticParams } from '@core/core/utils'
import { useSpa } from '@core/hooks'
import { Show } from '@library/components'
import { useBooleanFlagApi } from '@library/hooks'
import type { Nullable } from '@library/types'
import type { FC } from 'react'

import { PublishButton } from './PublishButton'
import { PublishingModal } from './PublishingModal'
import type { PublishingModalProps } from './types'

type PublishingProps = PublishingModalProps & {
  size?: ButtonPropSize
  view?: ButtonPropView
  createdBy: Nullable<string> | undefined
}

export const Publishing: FC<PublishingProps> = ({
  name,
  projectId,
  state,
  projectType,
  createdBy,
  size,
  view,
}) => {
  const sendSpaEvent = useSpa()

  const username = useAppSelector(selectPreferredName)

  const publishingModalApiRef = useBooleanFlagApi()

  const openPublishingModal = () => {
    publishingModalApiRef.current.setTrue()
    const dataAnalyticsId =
      state === 'Private' ? 'project_publication_click' : 'project_archive_click'
    sendSpaEvent(dataAnalyticsId, getProjectDataAnalyticParams(name, projectType))
  }

  return (
    <>
      <Show when={username === createdBy}>
        <PublishButton state={state} size={size} view={view} onClick={openPublishingModal} />
      </Show>
      <PublishingModal
        ref={publishingModalApiRef}
        name={name}
        projectId={projectId}
        state={state}
        projectType={projectType}
      />
    </>
  )
}
